import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  field_default_value: {
    id: 'form_field_default_value',
    defaultMessage: 'Default value',
  },
  field_default_value_description: {
    id: 'form_field_default_value_description',
    defaultMessage:
      'Value from the list that will already be selected when the form is opened.',
  },
});

/**
 * Envolve o fieldSchema do volto-form-block adicionando a propriedade
 * `default_value` aos campos do tipo lista (select).
 *
 * O extensor de schema padrão não recebe os dados do campo, por isso a opção
 * é adicionada aqui, onde é possível montar as escolhas a partir de
 * `input_values`.
 */
export const withSelectDefaultValue = (FieldSchema) => (props) => {
  const intl = useIntl();
  const schema = FieldSchema(props);

  if (props?.field_type !== 'select') {
    return schema;
  }

  return {
    ...schema,
    fieldsets: schema.fieldsets.map((fieldset) =>
      fieldset.id === 'default'
        ? {
            ...fieldset,
            fields: fieldset.fields.reduce((fields, field) => {
              fields.push(field);
              if (field === 'input_values') fields.push('default_value');
              return fields;
            }, []),
          }
        : fieldset,
    ),
    properties: {
      ...schema.properties,
      default_value: {
        title: intl.formatMessage(messages.field_default_value),
        description: intl.formatMessage(
          messages.field_default_value_description,
        ),
        type: 'string',
        choices: (props?.input_values ?? []).map((value) => [value, value]),
      },
    },
  };
};

export default withSelectDefaultValue;
